import { createApp } from 'vue'
import { createPinia } from 'pinia'
import '@/assets/css/Common.scss'
import '@/assets/css/reset.css'
import '@/assets/css/scrollbar.css'
import App from './App.vue'
import router from './router/index.js'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import Vant from "vant";
import "vant/lib/index.css";

const app = createApp(App)
// 自定义禁用右键
app.directive('disable-right-click', (bind,unbind)=>{
    bind.addEventListener('contextmenu', function(event) {
        event.preventDefault(); // 取消默认右键菜单显示
      });
  });
app.directive('prevent-click', (bind,unbind)=>{
  bind.addEventListener('click', () => {
    if (!bind.disabled) {
      bind.disabled = true
      setTimeout(() => {
        bind.disabled = false
      }, unbind.value || 3000)
    }
  })
});
app .use(createPinia())
    .use(Antd)
    .use(Vant)
    .use(ElementPlus, {
      locale: zhCn,
    })
    .use(router)
    .mount('#app')
